swatchChangeProducts = [];
upsellChangeProducts = [];
quickViewChangeProducts = [];
productAddons = [];
quickViewModalBaseHtml = document.querySelector('[data-quick-view-modal]')?.outerHTML;

const extractNumberFromPrice = (priceString) => {
    const match = priceString.match(/[\d,.]+/);
    if (match) {
        return parseFloat(match[0].replace(/,/g, ''));
    }
    return null;
}

const formDataToObject = (form) => {
    const setNestedValue = (obj, path, value) => {
        const parts = path.match(/[^\[\]]+/g);
        let current = obj;

        parts.forEach((part, index) => {
            if (index === parts.length - 1) {
                current[part] = value;
            } else {
                if (!current[part]) {
                    current[part] = isNaN(parts[index + 1]) ? {} : [];
                }
                current = current[part];
            }
        });
    }

    const formData = new FormData(form);
    const result = {};

    for (const [key, value] of formData.entries()) {
        setNestedValue(result, key, value);
    }

    return result;
}

const handleAddToCart = async (event, cart = {}, fromForm = false) => {

    if (fromForm) {
        event.preventDefault();
        event.stopPropagation();

        let formData = formDataToObject(cart);

        if (!formData.items) {
            cart = {
                items: [formData]
            };
        }
        else {
            cart = formData;
        }

        if (productAddons) {
            for (let [productAddonKey, productAddon] of Object.entries(productAddons)) {
                productAddon.forEach(productAddonItem => {
                    cart.items.push({
                        id: productAddonItem.id,
                        quantity: productAddonItem.quantity
                    })
                })
            }
        }
    }
    const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartDrawer) {
        cart.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    let response = {};
    try {
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cart)
        });
        response = await response.json();

        if (cartDrawer) {
            cartDrawer.renderContents(response);
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        }
    }
    catch (e) {
        console.error('Cart add api failed => ', e);
    }

    return response;
}

const handleProductHtmlUpdate = (selector, variantId) => {
    let existingProductContainerEl = document.querySelector(selector);
    if (existingProductContainerEl) {
        existingProductContainerEl.innerHTML = swatchChangeProducts[variantId]['section_html'];
        window.okeWidgetApi?.initAllWidgets();
        document.dispatchEvent(new CustomEvent("swym:product-loaded"));

        /*let html = (new DOMParser()).parseFromString(swatchChangeProducts[variantId]['section_html'], 'text/html');
        console.log(html);
        console.log(html.querySelectorAll('custom-modal-dialog'));
        html.querySelectorAll('custom-modal-dialog').forEach(modalEl => {
            let domModalEl = document.querySelector(modalEl.getAttribute('id'));
            console.log(domModalEl);
            if (domModalEl) {
                domModalEl.innerHTML = modalEl.innerHTML;
            }
        })*/
    }
}

const manageProductHtml = (save = true) => {
    if (!window.location.pathname.includes('/products/')) return;

    let selector = '[data-product-main]';
    let existingProductContainerEl = document.querySelector(selector);
    if (!existingProductContainerEl) return;

    let productUrl = window.location.pathname;
    let variantId = existingProductContainerEl.querySelector('[data-product-container]')?.getAttribute('data-variant-id');

    let searchParams = new URLSearchParams(window.location.search);

    if (save) {
        if (!swatchChangeProducts.hasOwnProperty(variantId)) {
            swatchChangeProducts[variantId] = {};
        }
        swatchChangeProducts[variantId]['section_html'] = existingProductContainerEl.innerHTML;
    }
    else {
        variantId = searchParams.get('variant');
        if (swatchChangeProducts.hasOwnProperty(variantId) && (swatchChangeProducts[variantId]['section_html'] || null)) {
            handleProductHtmlUpdate(selector, variantId);
        }
        variantId = existingProductContainerEl.querySelector('[data-product-container]')?.getAttribute('data-variant-id');
    }

    searchParams.set('variant', variantId);
    history.replaceState(null, null, `${window.location.origin}${productUrl}?${searchParams.toString()}`);

    /*if (!save) {
        window.location.href = '';
    }*/
}

manageProductHtml();

window.addEventListener('popstate', () => manageProductHtml(false));

class ProductMedia extends HTMLElement {
    constructor() {
        super();

        this.container = null;
        this.mediaItems = null;
        this.dotsContainer = null;
        this.specificationButton = null;
        this.specificationImage = null;
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.videoPlayBtns = this.querySelectorAll('.product-media [data-play-icon]');
        this.videoPlay();

        if (window.innerWidth > 1200) {
            return;
        }

        this.container = this.querySelector('.product-images-container');
        this.mediaItems = this.querySelectorAll('.product-media');
        this.dotsContainer = this.querySelector('.slider-dots');
        this.specificationButton = this.querySelector('#view-specification-button');
        this.specificationImage = this.querySelector('.product-media [alt="specification"]');

        if (!this.container || !this.mediaItems.length || !this.dotsContainer) {
            console.error('Product Media: Missing required elements');
            return;
        }

        this.setupDots();
        this.setupScrolling();
        this.redirectSpecificationImage();
    }

    setupDots() {
        this.mediaItems.forEach((ele, index) => {
            const dot = document.createElement('div');
            dot.classList.add('dot');
            if (index === 0) dot.classList.add('active');

            dot.addEventListener('click', () => this.scrollToMedia(index));
            this.dotsContainer.appendChild(dot);
        });
    }

    setupScrolling() {
        this.container.addEventListener('scroll', () => this.updateActiveDot());
        this.container.style.scrollSnapType = 'x mandatory';
        this.mediaItems.forEach((item) => {
            item.style.scrollSnapAlign = 'center';
        });

    }

    scrollToMedia(index) {
        const targetScroll = index * this.container.offsetWidth;
        this.container.scrollTo({
            left: targetScroll,
            behavior: 'smooth',
        });
        this.updateActiveDot(index);
    }

    updateActiveDot(currentIndex = null) {
        const containerWidth = this.container.offsetWidth;
        const scrollLeft = this.container.scrollLeft;
        const activeIndex = currentIndex ?? Math.round(scrollLeft / containerWidth);
        const dots = this.dotsContainer.querySelectorAll('.dot');

        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
        });
    }

    redirectSpecificationImage() {
        if (!this.specificationImage) {
            this.specificationButton.style.display = 'none';
        }
        this.specificationButton?.addEventListener('click', () => {
            this.specificationImage?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        });
    }

    videoPlay() {
        if (!this.videoPlayBtns) {
            return;
        }

        this.videoPlayBtns.forEach((videoBtn) => {
            videoBtn.addEventListener('click', () => {
                const video = videoBtn.closest('.product-media')?.querySelector('video');
                if (video.paused) {
                    video.play();
                    if (!video.hasAttribute('controls')) {
                        video.setAttribute('controls', '');
                    }
                    videoBtn.classList.add('d-none');
                }
            })
        })
    }
}

customElements.define('product-media', ProductMedia);

class ProductSwatch extends HTMLElement {
    constructor() {
        super();
        this.productUrl = this.getAttribute('data-product-url');
        this.sectionId = this.getAttribute('data-section-id');
        this.productId = this.getAttribute('data-product-id');
        this.variantId = this.getAttribute('data-variant-id');
        this.isVariantSwatch = this.getAttribute('data-product-variant') === 'true';
        this.optionName = this.getAttribute('data-option-name');
        this.optionValue = this.getAttribute('data-option-value');
        this.optionPosition = this.getAttribute('data-option-position');
        this.swatchHoverUpdateEl = document.querySelector(`[data-option-${this.optionName}-label]`);
        this.productContainerSelector = '[data-product-main]';
        this.selectedOptions = {};
        this.selectedOptionIds = [];
        this.selectedOptionsKey = '';

        if (this.productId) {
            this.product = document.querySelector(`#productJson_${this.productId}`)
            if (this.product) {
                this.product = JSON.parse(this.product.innerHTML);
            }
        }

        this.bindEvents();
    }

    bindEvents() {
        let productSwatchEl = this.querySelector('[data-product-swatch]');
        productSwatchEl?.addEventListener('click', (event) => this.handleSwatchClick(event));
        productSwatchEl?.addEventListener('mouseover', (event) => this.handleSwatchMouseOver(event));
        productSwatchEl?.addEventListener('mouseout', (event) => this.handleSwatchMouseOut(event));
    }

    async handleSwatchClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isVariantSwatch) {
            let selectedOptionsEl = document.querySelectorAll('product-swatch[data-product-variant="true"] .active-swatch');
            this.selectedOptions = {};
            this.selectedOptionIds = [];
            selectedOptionsEl.forEach(selectedOptionEl => {
                if (selectedOptionEl.parentElement?.getAttribute('data-option-position') === this.optionPosition) {
                    this.selectedOptions[this.optionPosition] = this.optionValue;
                    this.selectedOptionIds.push(this.getAttribute('data-option-id'));
                }
                else {
                    this.selectedOptions[selectedOptionEl.parentElement?.getAttribute('data-option-position')] = selectedOptionEl.parentElement?.getAttribute('data-option-value');
                    this.selectedOptionIds.push(selectedOptionEl.parentElement?.getAttribute('data-option-id'));
                }
            });

            this.selectedOptionsKey = this.selectedOptionIds.join(',');

            let selectedVariant = this.product?.variants?.find(variant => {
                return (variant.option1 === null && (this.selectedOptions[1] || null) === null ? true : variant.option1 === (this.selectedOptions[1] || null))
                    && (variant.option2 === null && (this.selectedOptions[2] || null) === null ? true : variant.option2 === (this.selectedOptions[2] || null))
                    && (variant.option3 === null && (this.selectedOptions[3] || null) === null ? true : variant.option3 === (this.selectedOptions[3] || null))
            });

            if (selectedVariant) {
                this.variantId = selectedVariant.id;

                if (!selectedVariant.available) {
                    this.handleUnavailableVariant();
                }
            }
        }

        this.parentElement?.querySelector('.active-swatch[data-product-swatch]')?.classList?.remove('active-swatch');
        this.querySelector('[data-product-swatch]')?.classList?.add('active-swatch');

        if (this.variantId) {
            if (!swatchChangeProducts.hasOwnProperty(this.variantId)) {
                swatchChangeProducts[this.variantId] = {};
            }
        }
        else {
            if (!swatchChangeProducts.hasOwnProperty(this.selectedOptionsKey)) {
                swatchChangeProducts[this.selectedOptionsKey] = {};
            }
        }

        if (
            this.variantId
            && swatchChangeProducts.hasOwnProperty(this.variantId)
            && (swatchChangeProducts[this.variantId]['section_html'] || null)
        ) {
            handleProductHtmlUpdate(this.productContainerSelector, this.variantId);
        }
        else if (
            swatchChangeProducts.hasOwnProperty(this.selectedOptionsKey)
            && (swatchChangeProducts[this.selectedOptionsKey]['section_html'] || null)
        ) {
            handleProductHtmlUpdate(this.productContainerSelector, this.selectedOptionsKey);
        }
        else {
            this.handleProductUpdate();
        }

        let searchParams = new URLSearchParams(window.location.search);
        if (this.variantId) {
            searchParams.set('variant', this.variantId);
            history.pushState(null, null, `${window.location.origin}${this.productUrl}?${searchParams.toString()}`);
        }
        else {
            searchParams.delete('variant');
            history.pushState(null, null, `${window.location.origin}${this.productUrl}?${searchParams.toString()}`);
        }
    }

    handleUnavailableVariant() {
        let selectors = ['.product-info add-to-cart-form [data-custom-add-to-cart-button]'];
        selectors.forEach(selector => {
            document.querySelector(selector)?.setAttribute('disabled', 'true');
        })
    }

    async handleProductUpdate() {
        try {
            let product = await fetch(`${this.productUrl}?sections=${this.sectionId}&option_values=${this.selectedOptionsKey}`);
            product = await product.json();
            let productSectionEl = (new DOMParser()).parseFromString(product[this.sectionId], 'text/html');
            let newProductSectionEl = productSectionEl.querySelector(this.productContainerSelector);
            if (newProductSectionEl) {
                swatchChangeProducts[this.variantId ? this.variantId : this.selectedOptionsKey]['section_html'] = newProductSectionEl.innerHTML;
                handleProductHtmlUpdate(this.productContainerSelector, this.variantId ? this.variantId : this.selectedOptionsKey);
            }
        }
        catch (e) {
            console.error('Error in product update section api => ', e);
        }
    }

    handleSwatchMouseOver(event) {
        if (!this.swatchHoverUpdateEl) return;

        this.swatchHoverUpdateEl.innerHTML = this.optionValue;
    }

    handleSwatchMouseOut(event) {
        if (!this.swatchHoverUpdateEl) return;

        let currentActiveSwatchEl = document.querySelector(`product-swatch[data-option-name="${this.optionName}"] .active-swatch`);
        if (currentActiveSwatchEl && currentActiveSwatchEl.parentElement) {
            this.swatchHoverUpdateEl.innerHTML = currentActiveSwatchEl.parentElement?.getAttribute('data-option-value');
        }
    }
}

customElements.define('product-swatch', ProductSwatch);

class ProductUpsell extends HTMLElement {
    constructor() {
        super();
        this.product = null;
        this.productUrl = null;
        this.sectionId = 'product-upsell';
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('[data-upsell-variant]').forEach(upsellVariantItemEl => {
            upsellVariantItemEl.addEventListener('click', (event) => this.updateUpsell(event, upsellVariantItemEl))
        })

        this.querySelectorAll('[data-custom-add-to-cart-button]').forEach(addToCartButtonEl => {
            addToCartButtonEl.addEventListener('click', async () => {

                let addToCartLoaderEl = this.querySelector('[data-custom-add-to-cart-loader]');

                addToCartLoaderEl?.classList?.remove('d-none');
                addToCartButtonEl?.classList?.add('custom-loading');

                try {
                    let variantId = this.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
                    if (variantId) {
                        let cartResponse = await handleAddToCart(
                            null,
                            {
                                items: [{
                                    id: variantId,
                                    quantity: 1
                                }]
                            },
                            false
                        )
                    }
                }
                catch (e) {
                    console.error(e);
                }

                addToCartLoaderEl?.classList?.add('d-none');
                addToCartButtonEl?.classList?.remove('custom-loading');
            })
        })
    }

    async updateUpsell(event, upsellVariantItemEl) {
        event.preventDefault();
        event.stopPropagation();

        this.productUrl = upsellVariantItemEl.getAttribute('data-upsell-variant-url');
        upsellVariantItemEl.closest('details')?.removeAttribute('open');

        if (!upsellChangeProducts.hasOwnProperty(this.productUrl)) {
            upsellChangeProducts[this.productUrl] = {};
        }

        if (
            upsellChangeProducts.hasOwnProperty(this.productUrl)
            && (upsellChangeProducts[this.productUrl]['section_html'] || null)
        ) {
            this.handleUpsellHtmlUpdate();
        }
        else {
            this.handleUpsellUpdate();
        }
    }

    async handleUpsellUpdate() {
        try {
            let product = await fetch(`${this.productUrl}?sections=${this.sectionId}`);
            product = await product.json();
            let productUpsellSectionEl = (new DOMParser()).parseFromString(product[this.sectionId], 'text/html');
            let newProductUpsellSectionEl = productUpsellSectionEl.querySelector('product-upsell');
            if (newProductUpsellSectionEl) {
                upsellChangeProducts[this.productUrl]['section_html'] = newProductUpsellSectionEl.outerHTML;
                this.handleUpsellHtmlUpdate();
            }
        }
        catch (e) {
            console.error('Error in upsell update api => ', e);
        }
    }

    handleUpsellHtmlUpdate() {
        this.outerHTML = upsellChangeProducts[this.productUrl]['section_html'];
    }
}

customElements.define('product-upsell', ProductUpsell);

class ProductAddonSwatch extends HTMLElement {
    constructor() {
        super();

        this.variantId = this.getAttribute('data-variant-id');
        this.addonUrl = this.getAttribute('data-addon-url');
        this.addonName = this.getAttribute('data-addon-name');
        this.addonValue = this.getAttribute('data-addon-value');
        this.addonTitle = this.getAttribute('data-addon-title');
        this.addonPrice = this.getAttribute('data-addon-price');
        this.addonAllowMultiple = this.getAttribute('data-addon-allow-multiple') === 'true';
        this.addonHoverUpdateEl = document.querySelector(`[data-addon-${this.addonName}-label]`);
        this.addonValuesEl = document.querySelector(`[data-addon-${this.addonName}-values]`);

        productAddons[this.addonName] = [];

        this.bindEvents();
    }

    bindEvents() {
        let productAddonEl = this.querySelector('[data-product-addon]');
        productAddonEl?.addEventListener('click', (event) => this.handleAddonClick(event));
        productAddonEl?.addEventListener('mouseover', (event) => this.handleAddonMouseOver(event));
        productAddonEl?.addEventListener('mouseout', (event) => this.handleAddonMouseOut(event));
    }

    handleAddonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        let productAddonEl = this.querySelector('[data-product-addon]');

        if (!this.addonAllowMultiple) {
            productAddons[this.addonName] = [];
        }

        if (productAddonEl) {
            if (productAddonEl?.classList?.contains('active-swatch')) {
                productAddons[this.addonName].splice(productAddons[this.addonName].findIndex(productAddon => productAddon.id === this.variantId), 1);
            }
            else {
                if (!productAddons[this.addonName].find(productAddon => productAddon.id === this.variantId)) {
                    productAddons[this.addonName].push({
                        id: this.variantId,
                        url: this.addonUrl,
                        quantity: 1,
                        title: this.addonTitle,
                        money: this.addonPrice,
                        price: extractNumberFromPrice(this.addonPrice),
                    });
                }
            }
        }

        let productAddonValuesHtml = '';
        if (productAddons[this.addonName].length) {
            productAddonValuesHtml = '<ul class="list-style-none mt-0 p-0 fs-14">';
            productAddons[this.addonName].forEach(productAddon => {
                productAddonValuesHtml += `<li class="d-flex justify-content-between gap-3">
                    <div>
                        <span>${productAddon.title}</span>
                        <span class="fw-bold">${productAddon.money}</span>
                    </div>
                    <div>
                        <custom-quick-view-opener
                            data-product-url="${productAddon.url}"
                            data-variant-id="${productAddon.id}"
                            data-addon-name="${this.addonName}"
                            data-quick-view-selector="custom-quick-view[data-modal-type='addon-quick-view']"
                            data-quick-view-modal-selector="#quickViewModal"
                        >
                            <span 
                                data-quick-view-button
                                data-modal-opener
                                data-modal="#quickViewModal"
                                class="d-block w-max-content text-decoration-underline cursor-pointer"
                            >
                                show more
                            </span>
                        </custom-quick-view-opener>
                    </div>
                </li>`;
            })
            productAddonValuesHtml += '</ul>';
        }

        if (this.addonValuesEl) {
            this.addonValuesEl.innerHTML = productAddonValuesHtml;
        }

        if (this.addonAllowMultiple) {
            productAddonEl?.classList?.toggle('active-swatch');
        }
        else {
            if (productAddonEl?.classList?.contains('active-swatch')) {
                this.parentElement?.querySelector('.active-swatch[data-product-addon]')?.classList?.remove('active-swatch');
            }
            else {
                this.parentElement?.querySelector('.active-swatch[data-product-addon]')?.classList?.remove('active-swatch');
                productAddonEl?.classList?.add('active-swatch');
            }
        }

        let totalPrice = 0;
        for (let [productAddonKey, productAddon] of Object.entries(productAddons)) {
            productAddon.forEach(productAddonItem => {
                totalPrice += productAddonItem.price;
            })
        }

        let productTotalPriceEl = document.querySelector('[data-product-total-price-wrapper]');
        if (totalPrice) {
            let productPrice = document.querySelector('[data-product-container]');
            productPrice = productPrice?.getAttribute('data-product-price');
            if (productPrice) {
                productTotalPriceEl?.classList.remove('d-none');
                productTotalPriceEl.querySelector('[data-product-total-price]').innerHTML = `$${(extractNumberFromPrice(productPrice) + totalPrice).toFixed(2)}`;
            }
        }
        else {
            productTotalPriceEl?.classList.add('d-none');
            productTotalPriceEl.querySelector('[data-product-total-price]').innerHTML = '';
        }
    }

    handleAddonMouseOver() {
        if (!this.addonHoverUpdateEl) return;

        this.addonHoverUpdateEl.innerHTML = this.addonValue;
    }

    handleAddonMouseOut() {
        if (!this.addonHoverUpdateEl) return;
        this.addonHoverUpdateEl.innerHTML = '';
    }
}

customElements.define('product-addon-swatch', ProductAddonSwatch);

class AddToCartForm extends HTMLElement {
    constructor() {
        super();
        for (let [productAddonKey, productAddon] of Object.entries(productAddons)) {
            productAddons[productAddonKey] = [];
        }

        this.quantityEl = this.querySelector('input[name="quantity"]');
        this.quantityPlusButtonEl = this.querySelector('[data-quantity-plus-button]');
        this.quantityMinusButtonEl = this.querySelector('[data-quantity-minus-button]');

        this.bindEvents();
    }

    bindEvents() {
        let cartFormEl = this.querySelector('form[action*="/cart/add"][data-custom-add-to-cart]');
        cartFormEl?.addEventListener('submit', async (event) => {
            let addToCartButtonEl = this.querySelector('[data-custom-add-to-cart-button]');
            let addToCartLoaderEl = this.querySelector('[data-custom-add-to-cart-loader]');

            addToCartLoaderEl?.classList?.remove('d-none');
            addToCartButtonEl?.classList?.add('custom-loading');

            try {
                await handleAddToCart(event, cartFormEl, true)
            }
            catch (e) {
                console.error(e);
            }

            addToCartLoaderEl?.classList?.add('d-none');
            addToCartButtonEl?.classList?.remove('custom-loading');
        });

        if (this.quantityEl.valueAsNumber <= 1) {
            this.quantityMinusButtonEl?.setAttribute('disabled', true);
        }

        this.quantityPlusButtonEl?.addEventListener('click', (event) => this.handleQuantityIncrease(event))
        this.quantityMinusButtonEl?.addEventListener('click', (event) => this.handleQuantityDecrease(event))
    }

    handleQuantityIncrease(event) {
        this.quantityEl.value = this.quantityEl.valueAsNumber + 1;
        if (this.quantityEl.valueAsNumber > 1) {
            this.quantityMinusButtonEl?.removeAttribute('disabled');
        }
    }

    handleQuantityDecrease(event) {
        this.quantityEl.value = this.quantityEl.valueAsNumber - 1;

        if (this.quantityEl.valueAsNumber <= 1) {
            this.quantityMinusButtonEl?.setAttribute('disabled', true);
        }
    }
}

customElements.define('add-to-cart-form', AddToCartForm);

class CustomQuickView extends HTMLElement {
    constructor() {
        super();

        this.variantId = this.getAttribute('data-variant-id');
        this.addonName = this.getAttribute('data-addon-name');
        this.modalSelector = this.getAttribute('data-quick-view-modal-selector');

        this.productAddonIndex = (productAddons[this.addonName] || []).findIndex(productAddon => productAddon.id === this.variantId);
        if (this.productAddonIndex === -1) return;

        this.quantityEl = this.querySelector('[name="quantity"]');
        this.quantityPlusButtonEl = this.querySelector('[data-quantity-plus-button]');
        this.quantityMinusButtonEl = this.querySelector('[data-quantity-minus-button]');

        this.bindEvents();
    }

    bindEvents() {
        this.querySelector('[data-save-button]').addEventListener('click', () => this.handleSave());
        this.quantityPlusButtonEl?.addEventListener('click', (event) => this.handleQuantityIncrease(event))
        this.quantityMinusButtonEl?.addEventListener('click', (event) => this.handleQuantityDecrease(event))
    }

    handleQuantityIncrease() {
        if (!this.quantityEl) return;

        this.quantityEl.value = this.quantityEl.valueAsNumber + 1;
        if (this.quantityEl.valueAsNumber > 1) {
            this.quantityMinusButtonEl?.removeAttribute('disabled');
        }
    }

    handleQuantityDecrease() {
        if (!this.quantityEl) return;

        this.quantityEl.value = this.quantityEl.valueAsNumber - 1;

        if (this.quantityEl.valueAsNumber <= 1) {
            this.quantityMinusButtonEl?.setAttribute('disabled', true);
        }
    }

    handleSave() {
        productAddons[this.addonName][this.productAddonIndex].quantity = this.quantityEl.valueAsNumber;
        document.querySelector(this.modalSelector)?.querySelector('[id^="ModalClose-"]')?.click();
    }
}

customElements.define('custom-quick-view', CustomQuickView);

class CustomQuickViewOpener extends HTMLElement {
    constructor() {
        super();

        this.productUrl = this.getAttribute('data-product-url');
        this.variantId = this.getAttribute('data-variant-id');
        this.addonName = this.getAttribute('data-addon-name');
        this.quickViewModalSelector = this.getAttribute('data-quick-view-modal-selector');
        this.quickViewSelector = this.getAttribute('data-quick-view-selector');
        this.quickViewOpenerEl = this.querySelector('[data-quick-view-button]');
        this.bindEvents();
    }

    bindEvents() {
        this.quickViewOpenerEl?.addEventListener('click', (event) => this.handleQuickView(event));
    }

    async handleQuickView() {
        if (!quickViewChangeProducts.hasOwnProperty(this.variantId)) {
            quickViewChangeProducts[this.variantId] = {};
        }

        if (quickViewChangeProducts.hasOwnProperty(this.variantId) && quickViewChangeProducts[this.variantId].id) {
            this.handleQuickViewHtmlUpdate();
        }
        else {
            try {
                let product = await fetch(`${this.productUrl}.js`);
                product = await product.json();
                if (product && product.id) {
                    product.selected_variant = product.variants?.find(variant => variant.id.toString() === this.variantId);
                    quickViewChangeProducts[this.variantId] = product;
                    this.handleQuickViewHtmlUpdate();
                }
            }
            catch (e) {
                console.error('Error in quick view rendering => ', e);
            }
        }
    }

    handleQuickViewHtmlUpdate() {
        let addonProduct = quickViewChangeProducts[this.variantId] || null;
        if (!addonProduct) return;

        let existingQuickViewContainerEl = (new DOMParser()).parseFromString(quickViewModalBaseHtml, 'text/html');
        existingQuickViewContainerEl = existingQuickViewContainerEl.querySelector(this.quickViewSelector);

        existingQuickViewContainerEl.setAttribute('data-variant-id', this.variantId);
        existingQuickViewContainerEl.setAttribute('data-addon-name', this.addonName);
        existingQuickViewContainerEl.setAttribute('data-quick-view-modal-selector', this.quickViewModalSelector);

        if (!existingQuickViewContainerEl) return;

        const isDiscounted = addonProduct.price < addonProduct.compare_at_price;

        let addonProductImageWrapperLinkEl = existingQuickViewContainerEl.querySelector('.quick-view-image-wrapper');
        if (addonProductImageWrapperLinkEl) {
            addonProductImageWrapperLinkEl.href = addonProduct.url;

            let addonProductImageEl = existingQuickViewContainerEl.querySelector('.quick-view-image');
            if (addonProductImageEl) {
                addonProductImageEl.src = `${addonProduct.images[0]}?width=400`;
                addonProductImageEl.alt = addonProduct.title;
            }
        }

        let addonProductCardTitleEl = existingQuickViewContainerEl.querySelector('.quick-view-title');
        if (addonProductCardTitleEl) {
            addonProductCardTitleEl.innerHTML = addonProduct.title;
        }

        let addonProductCardCompareAtPriceEl = existingQuickViewContainerEl.querySelector('.product-price-wrapper .product-compare-price');
        let addonProductCardPriceEl = existingQuickViewContainerEl.querySelector('.product-price-wrapper .quick-view-price');
        if (addonProductCardPriceEl) {
            if (isDiscounted) {
                addonProductCardCompareAtPriceEl.classList.remove('d-none');
                addonProductCardCompareAtPriceEl.innerHTML = `${window.Shopify?.formatMoney(addonProduct.compare_at_price)}`;
                addonProductCardPriceEl.classList.add('product-price', 'text-red');
            }
            addonProductCardPriceEl.innerHTML = `${window.Shopify?.formatMoney(addonProduct.price)}`;
        }

        let mainQuickViewModalContentEl = document.querySelector(this.quickViewSelector);
        if (mainQuickViewModalContentEl) {
            mainQuickViewModalContentEl.outerHTML = existingQuickViewContainerEl.outerHTML;
        }

        let quickViewModalEl = document.querySelector(this.quickViewModalSelector);
        if (quickViewModalEl) quickViewModalEl.show(this.quickViewOpenerEl);
    }
}

customElements.define('custom-quick-view-opener', CustomQuickViewOpener);

class CustomRecentlyViewed extends HTMLElement {
    constructor() {
        super();

        this.productId = this.getAttribute('data-product-id');
        this.product = document.querySelector(`#productJsonWithAllFields_${this.productId}`);
        this.baseProductCardHtml = this.querySelector(`#productJsonWithAllFields_${this.productId}`);
        if (this.product) {
            this.product = JSON.parse(this.product.innerHTML);
            this.init();
        }
    }

    init() {
        if (!this.product) return;

        let baseProductCardHtmlDom = this.querySelector('[data-product-card-reference]');
        if (!baseProductCardHtmlDom) return;

        this.baseProductCardHtml = baseProductCardHtmlDom.innerHTML;
        baseProductCardHtmlDom.remove();

        this.storeProductInSessionStorage();
        this.renderRecentlyViewedProducts();
    }

    storeProductInSessionStorage() {
        let products = JSON.parse(sessionStorage.getItem('recently_viewed_products')) || [];

        if (!products.find(p => p.id === this.product.id)) {
            products.push(this.product);
        }

        if (products.length > 10) {
            products = products.slice(-10);
        }

        sessionStorage.setItem('recently_viewed_products', JSON.stringify(products));
    }

    renderRecentlyViewedProducts() {
        const products = JSON.parse(sessionStorage.getItem('recently_viewed_products')) || [];
        const container = document.getElementById('recently-viewed-products');

        products.slice().reverse()
            .filter(product => product.id !== this.product.id)
            .forEach(product => {

                let productCardHtml = (new DOMParser()).parseFromString(this.baseProductCardHtml, 'text/html');
                productCardHtml = productCardHtml.querySelector('product-card');

                if (!productCardHtml) return;

                let productDetailsWrapper = productCardHtml.querySelector('.product-card-v2-detail-wrapper');

                const isDiscounted = product.price < product.compare_at_price;

                let productImageWrapperLinkEl = productCardHtml.querySelector('.product-image-wrapper');
                if (productImageWrapperLinkEl) {
                    productImageWrapperLinkEl.href = product.url;

                    let productImageEl = productCardHtml.querySelector('img');
                    if (productImageEl) {
                        productImageEl.src = `${product.images[0]}?width=400`;
                        productImageEl.alt = product.title;
                        productImageEl.removeAttribute('srcset');
                    }
                }

                let wishlistButton = productCardHtml.querySelector('button.swym-button');
                if (wishlistButton) {
                    wishlistButton.setAttribute('data-product-id', product.id);
                    wishlistButton.setAttribute('data-variant-id', product.selected_or_first_available_variant.id);
                    wishlistButton.setAttribute('data-product-url', `https://${Shopify.shop}${product.url}`);

                    wishlistButton.className = wishlistButton.className.replace(/product_\d+/, '');
                    wishlistButton.classList.add(`product_${product.id}`);
                }

                let productCardTitleEl = productCardHtml.querySelector('.product-card-title');
                if (productCardTitleEl) {
                    productCardTitleEl.setAttribute('href', product.url);
                    productCardTitleEl.innerHTML = product.title;
                }

                let productCardPriceEl = productCardHtml.querySelector('.product-price-wrapper');
                if (productCardPriceEl) {
                    productCardPriceEl.innerHTML = '';
                    if (isDiscounted) {
                        productCardPriceEl.innerHTML = `<s class="product-compare-price text-white-100">
                        ${product.compare_at_price_money}
                    </s>`;
                    }

                    productCardPriceEl.innerHTML += `<span class="text-black ${isDiscounted ? 'product-price text-red' : ''}">
                    ${product.price_money}
                </span>`;
                }

                let colorSwatches = product.metafields?.colours || [];
                let colorSwatchesEl = productCardHtml.querySelector('.item-swatches-wrapper');
                let colorSwatchesHtml = '';
                if (colorSwatches?.length) {
                    colorSwatches.forEach(colorSwatch => {
                        colorSwatchesHtml += `<a href="${colorSwatch.url}" class="swatch-image-wrapper ${product.id === colorSwatch.id ? 'active-swatch' : ''}">
                        <img src="${colorSwatch.featured_image}?width=35"
                             class="swatch-image hover-image-zoom"
                             loading="lazy"
                             alt="${colorSwatch.title}"
                             width="auto"
                             height="auto"
                        >
                    </a>`;
                    })

                    if (colorSwatchesEl) {
                        colorSwatchesEl.innerHTML = colorSwatchesHtml;
                    }
                    else {
                        if (productDetailsWrapper) {
                            productDetailsWrapper.innerHTML = `<div class="item-swatches-wrapper d-flex flex-wrap">${colorSwatchesHtml}</div>` + productDetailsWrapper.innerHTML;
                        }
                    }
                }
                else {
                    if (colorSwatchesEl) colorSwatchesEl.outerHTML = '';
                }

                let sizesCount = (product.metafields?.sizes || []).length;
                let productSizesCountEl = productCardHtml.querySelector('.product-size-wrapper .product-size');
                if (!sizesCount) {
                    if (productSizesCountEl) productSizesCountEl.outerHTML = '';
                }
                else {
                    if (productSizesCountEl) {
                        productSizesCountEl.innerHTML = `${sizesCount} Sizes Available`;
                    } else {
                        if (productDetailsWrapper) {
                            productDetailsWrapper.innerHTML += `<div class="product-size-wrapper">
                            <span class="product-size text-white-200">
                                ${sizesCount} Sizes Available
                            </span>
                        </div>`;
                        }
                    }
                }

                container.innerHTML += `<div class="swiper-slide">
                    ${productCardHtml.outerHTML}
                </div>`;
            })
    }
}

customElements.define('custom-recently-viewed', CustomRecentlyViewed);
